import { render, staticRenderFns } from "./Aliplayer.vue?vue&type=template&id=58d17e06&scoped=true"
import script from "./Aliplayer.vue?vue&type=script&lang=js"
export * from "./Aliplayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d17e06",
  null
  
)

export default component.exports